import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Navbar from './components/Navbar'; 
import HamburgerMenu from './components/HamburgerMenu'; 
import LandingOne from './components/LandingOne';
import TikTokButton from './components/TikTokButton';
import logoImage from '../images/ic_text.png';

const Landing = () => {
    gsap.registerPlugin(ScrollTrigger);

    const containerRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [currentSection, setCurrentSection] = useState('section1');
    const logoRef = useRef(null);
    const topLeftLogoRef = useRef(null);
    const topLeftLogoStyle = {
        position: 'fixed',
        top: '1.1rem',
        left: '2rem',
        padding: '2rem',
        cursor: 'pointer',
        width: '25rem',
        zIndex: 100,
        display: isMobile ? 'none' : 'block',
    };

    const handleLogoClick = () => {
        var element = document.getElementById('section1');
        window.lenis.scrollTo(element);
    };

    return (
        <div ref={containerRef}>
            <TikTokButton />
            <LandingOne 
                isMobile={isMobile} 
            />
        </div>
    );
}

export default Landing